import { createChannelManagementInstance } from '../api-instance';
import type { TRequestOptions } from '../types';

export interface AvitoConnectRequest {
  client_id: string;
  client_secret: string;
  name?: string;
}

export interface AvitoConnectResponse {
  status: 'authorized' | 'ready';
  avitoUserId: string;
}

export const connectAvito = (
  channelId: string,
  data: AvitoConnectRequest,
  options?: TRequestOptions
): Promise<AvitoConnectResponse> =>
  createChannelManagementInstance<AvitoConnectResponse>(
    {
      url: `/api/v1/channels/${encodeURIComponent(channelId)}/avito/connect`,
      method: 'POST',
      data,
    },
    options
  );

export const disconnectAvito = (
  channelId: string,
  options?: TRequestOptions
): Promise<void> =>
  createChannelManagementInstance<void>(
    {
      url: `/api/v1/channels/${encodeURIComponent(channelId)}/avito/disconnect`,
      method: 'POST',
      data: {},
    },
    options
  );
